function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

// Tienda
export default [
  {
    path: 'shop/categories/create',
    name: 'ShopCategoryCreate',
    component: loadView('Back/Shop/Category/CreateOrEdit')
  },
  {
    path: 'shop/categories/:categoryId/edit',
    name: 'ShopCategoryEdit',
    component: loadView('Back/Shop/Category/CreateOrEdit')
  },
  {
    path: 'shop/categories/:categoryId/subcategories/create',
    name: 'ShopSubCategoryCreate',
    component: loadView('Back/Shop/SubCategory/CreateOrEdit')
  },
  {
    path: 'shop/categories/:categoryId/subcategories/:subCategoryId/edit',
    name: 'ShopSubCategoryEdit',
    component: loadView('Back/Shop/SubCategory/CreateOrEdit')
  },
  {
    path: 'shop/products/create',
    name: 'ProductCreate',
    component: loadView('Back/Shop/Product/CreateOrEdit')
  },
  {
    path: 'shop/products/:productId/edit',
    name: 'ProductEdit',
    component: loadView('Back/Shop/Product/CreateOrEdit')
  }
]
